import * as Types from '@mildang/graphql-artifact';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FindAccountsByPhoneQueryVariables = Types.Exact<{
  input: Types.FindAccountsByPhoneInput;
}>;


export type FindAccountsByPhoneQuery = { __typename?: 'Query', findAccountsByPhone: { __typename: 'FindAccountsByPhonePayload', accounts: Array<{ __typename: 'AccountWithEmailHidden', id: string, email: string, createdAt: any }> } };


export const FindAccountsByPhoneDocument = gql`
    query FindAccountsByPhone($input: FindAccountsByPhoneInput!) {
  findAccountsByPhone(input: $input) {
    accounts {
      id
      email
      createdAt
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useFindAccountsByPhoneQuery__
 *
 * To run a query within a React component, call `useFindAccountsByPhoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAccountsByPhoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAccountsByPhoneQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindAccountsByPhoneQuery(baseOptions: Apollo.QueryHookOptions<FindAccountsByPhoneQuery, FindAccountsByPhoneQueryVariables> & ({ variables: FindAccountsByPhoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAccountsByPhoneQuery, FindAccountsByPhoneQueryVariables>(FindAccountsByPhoneDocument, options);
      }
export function useFindAccountsByPhoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAccountsByPhoneQuery, FindAccountsByPhoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAccountsByPhoneQuery, FindAccountsByPhoneQueryVariables>(FindAccountsByPhoneDocument, options);
        }
export function useFindAccountsByPhoneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAccountsByPhoneQuery, FindAccountsByPhoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAccountsByPhoneQuery, FindAccountsByPhoneQueryVariables>(FindAccountsByPhoneDocument, options);
        }
export type FindAccountsByPhoneQueryHookResult = ReturnType<typeof useFindAccountsByPhoneQuery>;
export type FindAccountsByPhoneLazyQueryHookResult = ReturnType<typeof useFindAccountsByPhoneLazyQuery>;
export type FindAccountsByPhoneSuspenseQueryHookResult = ReturnType<typeof useFindAccountsByPhoneSuspenseQuery>;
export type FindAccountsByPhoneQueryResult = Apollo.QueryResult<FindAccountsByPhoneQuery, FindAccountsByPhoneQueryVariables>;
export const namedOperations = {
  Query: {
    FindAccountsByPhone: 'FindAccountsByPhone'
  }
}